<div class="header-label">
  <h2>User Administrators</h2>
</div>

<!-- Filter row -->
<div class="filter-row">
  <mat-form-field appearance="outline" class="search-bar" subscriptSizing="dynamic">
    <mat-label>User Name</mat-label>
    <input matInput [(ngModel)]="filter.userName" placeholder="Type username...">
  </mat-form-field>

  <mat-form-field appearance="outline" class="search-bar" subscriptSizing="dynamic">
    <mat-label>First Name</mat-label>
    <input matInput [(ngModel)]="filter.firstName" placeholder="Type first name...">
  </mat-form-field>

  <mat-form-field appearance="outline" class="search-bar" subscriptSizing="dynamic">
    <mat-label>Last Name</mat-label>
    <input matInput [(ngModel)]="filter.lastName" placeholder="Type last name...">
  </mat-form-field>

  <mat-form-field appearance="outline" class="search-bar" subscriptSizing="dynamic">
    <mat-label>Email</mat-label>
    <input matInput [(ngModel)]="filter.email" placeholder="Type email...">
  </mat-form-field>

  <div class="filter-button-wrap">
    <button mat-flat-button color="primary" (click)="onFilter()">Filter</button>
  </div>
</div>

<!-- Error banner -->
<div *ngIf="errorMessage" class="api-error-banner">
  {{ errorMessage }}
</div>

<!-- Loading -->
<div class="table-loader" *ngIf="loading">
  <mat-spinner [diameter]="50"></mat-spinner>
</div>

<!-- Table -->
<div class="table-wrapper" [class.loading]="loading" [hidden]="!clientId">

  <table mat-table [dataSource]="dataSource" matSort [matSortActive]="sortBy" [matSortDirection]="sortDir">

    <ng-container matColumnDef="userName">
      <th mat-header-cell *matHeaderCellDef mat-sort-header="userName">User Name</th>
      <td mat-cell *matCellDef="let row">{{ row.userName }}</td>
    </ng-container>

    <ng-container matColumnDef="firstName">
      <th mat-header-cell *matHeaderCellDef mat-sort-header="firstName">First Name</th>
      <td mat-cell *matCellDef="let row">{{ row.firstName }}</td>
    </ng-container>

    <ng-container matColumnDef="lastName">
      <th mat-header-cell *matHeaderCellDef mat-sort-header="lastName">Last Name</th>
      <td mat-cell *matCellDef="let row">{{ row.lastName }}</td>
    </ng-container>

    <ng-container matColumnDef="email">
      <th mat-header-cell *matHeaderCellDef mat-sort-header="email">Email</th>
      <td mat-cell *matCellDef="let row">{{ row.email }}</td>
    </ng-container>

    <ng-container matColumnDef="office">
      <th mat-header-cell *matHeaderCellDef mat-sort-header="office">Office</th>
      <td mat-cell *matCellDef="let row">{{ row.office }}</td>
    </ng-container>

    <ng-container matColumnDef="locked">
      <th mat-header-cell *matHeaderCellDef mat-sort-header="locked">Locked</th>
      <td mat-cell *matCellDef="let row">
        <mat-icon class="status-icon status-warn" *ngIf="row.locked">lock</mat-icon>
      </td>
    </ng-container>

    <ng-container matColumnDef="approved">
      <th mat-header-cell *matHeaderCellDef mat-sort-header="approved">Approved</th>
      <td mat-cell *matCellDef="let row">
        <mat-icon class="status-icon" [class.active]="row.approved">
          {{ row.approved ? 'check_circle' : 'cancel' }}
        </mat-icon>
      </td>
    </ng-container>

    <ng-container matColumnDef="actions">
      <th mat-header-cell *matHeaderCellDef class="no-header"></th>
      <td mat-cell *matCellDef="let row" class="actions-cell">
        <button mat-icon-button matTooltip="Edit" class="table-action-btn table-action-edit"
                (click)="openEdit(row); $event.stopPropagation()">
          <mat-icon>edit</mat-icon>
        </button>
      </td>
    </ng-container>

    <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
    <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>

  </table>

  <div *ngIf="dataSource.data.length === 0 && !loading" class="no-results-message">
    No users found
  </div>

</div>

<!-- Paginator -->
<mat-paginator
  [length]="totalCount"
  [pageIndex]="pageIndex"
  [pageSize]="pageSize"
  [pageSizeOptions]="[10, 20, 50]"
  (page)="onPageChange($event)"
  showFirstLastButtons>
</mat-paginator>

<!-- Edit dialog -->
<ng-template #userDialog>
  <h2 mat-dialog-title>Edit User</h2>

  <form #userForm="ngForm" (ngSubmit)="save(userForm)">
    <mat-dialog-content class="dialog-content">

      <div *ngIf="dialogError" class="api-error-banner dialog-error">{{ dialogError }}</div>

      <div class="dialog-username">
        <span class="dialog-label">User Name:</span>
        <span class="dialog-value">{{ model.userName }}</span>
      </div>

      <div class="dialog-fields">
        <mat-form-field appearance="outline" class="dialog-field">
          <mat-label>First Name</mat-label>
          <input matInput name="firstName" [(ngModel)]="model.firstName" required
                 #firstNameField="ngModel">
          <mat-error *ngIf="firstNameField.hasError('required')">First Name is required.</mat-error>
        </mat-form-field>

        <mat-form-field appearance="outline" class="dialog-field">
          <mat-label>Last Name</mat-label>
          <input matInput name="lastName" [(ngModel)]="model.lastName" required
                 #lastNameField="ngModel">
          <mat-error *ngIf="lastNameField.hasError('required')">Last Name is required.</mat-error>
        </mat-form-field>

        <mat-form-field appearance="outline" class="dialog-field">
          <mat-label>Email</mat-label>
          <input matInput type="email" name="email" [(ngModel)]="model.email" required email
                 #emailField="ngModel">
          <mat-error *ngIf="emailField.hasError('required')">Email is required.</mat-error>
          <mat-error *ngIf="emailField.hasError('email')">Please enter a valid email address.</mat-error>
        </mat-form-field>
      </div>

      <div class="dialog-flags">
        <mat-checkbox *ngIf="showLockedCheckbox" name="locked" [(ngModel)]="model.locked">
          Locked
        </mat-checkbox>
        <mat-checkbox *ngIf="!model.newUser" name="approved" [(ngModel)]="model.approved">
          Approved
        </mat-checkbox>
      </div>

      <!-- Offices -->
      <div class="offices-section">
        <div class="offices-header">
          <span class="offices-title">Offices</span>
          <mat-checkbox [(ngModel)]="selectAllOffices" name="selectAll" labelPosition="before"
                        (ngModelChange)="onToggleSelectAll($event)">
            Select All
          </mat-checkbox>
        </div>
        <div class="offices-scroll">
          <table class="offices-table">
            <thead>
              <tr>
                <th>Office Name</th>
                <th>Access</th>
              </tr>
            </thead>
            <tbody>
              <tr *ngFor="let office of offices; let i = index" [class.alt-row]="i % 2 !== 0">
                <td>{{ office.mailingName }}</td>
                <td class="access-cell">
                  <mat-checkbox
                    [checked]="isOfficeSelected(office.claimOfficeId)"
                    (change)="toggleOffice(office.claimOfficeId, $event.checked)">
                  </mat-checkbox>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>

    </mat-dialog-content>

    <mat-dialog-actions align="end">
      <button mat-flat-button color="primary" type="submit">Submit</button>
      <button mat-stroked-button type="button" (click)="closeDialog()">Cancel</button>
    </mat-dialog-actions>
  </form>
</ng-template>
